export const appusers = {
  appusersSearch: 'Sök'
}
